import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DevicesProvider } from './../../providers/devices/devices';
import { TaskQL } from '../../providers/tasks/models';
import { UtilsProvider } from '../../providers/utils/utils';

@Component({
  selector: 'task-block',
  templateUrl: './task-block.component.html',
})
export class TaskBlockComponent implements OnInit , OnChanges{

  constructor(
    private devicesProvider: DevicesProvider,
    public utilsProvider: UtilsProvider,
  ) {
  }
  @Input('task') task: any;
  @Input('providers') providers: any;

  public remainingTime: string;
  public hasRemainingTime = false;
  public hadRemainingTime = false;
  public timerInterval;
  public needsInvoice;

  ngOnInit() {
    this.getRemainingScheduleTime(this.task.createdDate);
    this.checkInvoiceState();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  getProviderColor(id) {
    let provider = this.providers.filter(itm => itm.id === id)[0];
    let clr = provider && provider.color ? provider.color : '#666';
    return clr;
  }


  getRemainingScheduleTime(id: string){
    if (this.task.status === "scheduled" || this.task.status === "closed" || this.task.status === "inprogress") {
      // if scheduled then we do not need to show the time
      this.hasRemainingTime = false;
      this.hadRemainingTime = false;
    } else if (this.task.schedulerMeta?.expiredTime) {
      // show the time if there is a future expiry time. 
      // we define hadRemainingTime as true, so we can show the red expired time 
      // to the user if it expired while this view was active
      this.hasRemainingTime = this.task.schedulerMeta?.expiredTime > new Date().getTime();
      this.hadRemainingTime = this.hasRemainingTime;
      this.remainingTime = this.getCountdownRemainder(this.task.schedulerMeta?.expiredTime);
    } else {
      // otherwise do not show
      this.hasRemainingTime = false;
      this.hadRemainingTime = false;
    }
    if (this.hasRemainingTime) {
      // start the timer if
      this.scheduleCountdownTimer();
    }
  }
  
  getCountdownRemainder(expireTime: number){
    const duration = expireTime - new Date().getTime();
    const remaining = duration;
    if(remaining < 0) {
      clearInterval(this.timerInterval);
      this.hasRemainingTime = false;
      return "00:00"
    }
    return this.utilsProvider.millisToMinutesAndSeconds(remaining, true)
  }

  scheduleCountdownTimer(){
    this.timerInterval = setInterval(() => {
      this.hasRemainingTime = false
      this.hasRemainingTime = true;
      this.remainingTime = this.getCountdownRemainder(this.task.schedulerMeta?.expiredTime);
    }, 1000)
  }

  shortAddress(address){
    return address.split(',').slice(0,2);
  }

  checkInvoiceState() {
    if (this.task.status === 'closed') {
      this.utilsProvider.hasInvoice(this.task.id).subscribe(
        response => {
          if (response === null) {
            this.needsInvoice = true;
          } else {
            this.needsInvoice = false;
          }
        },
        error => {
          this.needsInvoice = true;
        },
      );
    } else {
      this.needsInvoice = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/task-block/task-block.component.ts